export default __webpack_public_path__ + "static/media/scania_convierte_tus_costos_fijos_en_variables_presentacion.f8796872.pdf";